import {Container} from '@mui/material';
import {Outlet} from 'react-router-dom';

export const AppLayout = () => (
  <>
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#f0f0f0',
      }}
    >
      <Container
        maxWidth="xs"
        sx={{
          maxWidth: '100%',
          minHeight: '100vh',
          backgroundImage: `url("${process.env.REACT_APP_CDN}/space.png")`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <Outlet />
      </Container>
    </div>
  </>
);
